import Vue from 'vue'
import Vuex from 'vuex'
import { InvoiceResource } from "@/resources/Invoice.resource.js";

Vue.use(Vuex)

export default {
    state : {
      invoicePayments: [[]],
      loadingInvoicePayments : false ,
      //internalMerchantFiles: [[]]
    },
    mutations: {
        setInvoicePayments(state, {idInvoice, invoicePayments}) {
     //   console.log("setMerchantFiles", merchantFiles);

       // state.internalMerchantFiles[idMerchant, merchantFiles];
        state.invoicePayments[idInvoice] = invoicePayments;  
        state.loadingInvoicePayments = false
      },
        setLoadingInvoicePayments(state, status)
        {
            state.loadingInvoicePayments =  status;
        }
    },
    actions: {
        invoicePayments : ({commit, state}, item) => {



       let filtrosLocal= {
        idInvoice: item.payload,
       
      };
  
   console.log("invoicePayments", item);
     
        return new Promise((resolve, reject) => {
            commit('setLoadingInvoicePayments', {status: true});

         
            InvoiceResource.getListaInvoicePayment(filtrosLocal).then((response) => {
              if (response.data.isSuccess) {
             
                commit('setInvoicePayments',{ idInvoice: item.payload, invoicePayments: response.data.payload});
               
                resolve(response.data.payload);
              } else {
                reject();
              }
            })
            .catch((e) => {
              reject();
            })
        
        });
      }
    },
    getters: {
      getInvoicePayments: (state) => {
        return state.invoicePayments 
      },
      getLoadInvoicePayments: (state)=> {
          return state.loadingInvoicePayments
      }
    },
  }
  